module.exports = __webpack_public_path__ + "img/austria-endocrine-nutritional-metabolic-diseases-male.cb5ce9b6.png";